<template >
    <v-dialog v-model="dialog" max-width="80%" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"  persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="formTitle"></span></v-card-title>
            <v-card-text>
                <v-form ref="form_aseguradora" :lazy-validation="false">
                    <v-container>
                        <v-row dense class="mb-3">
                            <v-col cols="12">
                                <img :src="editedItem.logo" class="float-right" height="100" style="width:6cm"  v-if="_.size(editedItem.logo) > 0"/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="RUC *" color="textbox" v-model="editedItem.ruc" :rules="_.concat(requeridoRegla,ruc)" counter="13" outlined/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Nombre Aseguradora *" color="textbox" v-model.trim="editedItem.nombre" outlined :rules="_.concat(requeridoRegla,companiaRegla)"/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Representante Legal *" color="textbox" v-model.trim="editedItem.representanteLegal" validate-on-blur :rules="_.concat(requeridoRegla,soloLetrasRegla(1,editedItem.representanteLegal,300))" outlined/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Télefono" color="textbox" v-model="editedItem.telefono" v-mask="maskTelefono" :rules="_.size(editedItem.telefono) > 0 ? soloNumerosRegla(9,editedItem.telefono,9) : []" outlined/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Celular" color="textbox" v-model="editedItem.celular" v-mask="maskCelular" :rules="_.size(editedItem.celular) > 0 ? soloNumerosRegla(10,editedItem.celular,10) : []"  outlined/>
                            </v-col>        
                            <v-col cols="12" sm="4">   
                                <v-text-field dense label="Email" color="textbox" v-model.trim="editedItem.email" :rules="_.size(editedItem.email) > 0  ? emailRegla : []" outlined/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete dense label="Provincia *" color="textbox" v-model="editedItem.idProvincia" :items="listaProvincias" @change="onListarCantones" :rules="requeridoRegla" outlined/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete dense label="Cantón *" color="textbox" v-model="editedItem.idCanton" item-text="canton" item-value="idCanton" :items="listaCantones" :rules="requeridoRegla" outlined/>
                            </v-col>
                        </v-row>
                        <v-row dense>   
                            <v-col cols="12" >
                                <v-textarea dense label="Dirección *" color="textbox" v-model.trim="editedItem.direccion" :value="editedItem.direccion" counter="300" :rules="_.concat(requeridoRegla,max300Regla)" outlined/>
                            </v-col>
                        </v-row>
                        <v-row dense>    
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Página Web" color="textbox" v-model.trim="editedItem.paginaWeb" :rules="(_.size(editedItem.paginaWeb) > 0)  ? _.concat(urlRegla) : []" outlined/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete dense label="Estado *" color="textbox" v-model="editedItem.estado" :items="listaEstados" item-text="nombre_estado" item-value="id_estado" :rules="requeridoRegla" outlined/>
                            </v-col>
                            <v-col cols="12" sm="4" class="text-center">
                                <v-tooltip right color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mt-3" color="primary" @click="pickFile" v-html="'cloud_upload'" v-on="on"/>
                                        <input type="file" style="display: none" ref="image" accept="image/gif, image/jpeg, image/png" @change="onFilePicked"/>
                                    </template>
                                    <span>Subir Icono</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cargaGeneral();close();">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="submit">Guardar</v-btn>
                            </v-col>
                        </v-row>   
                    </v-container>
                </v-form>    
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        props: ['editedItem', 'formTitle','itemsProvincias','itemsCantones','itemsEstados','dialog'],
        inject: ['close', 'save','onListar'],
        directives:{mask},
        data (){
            return {
                imageName: null,
                imageUrl: null,
                imageFile: null,
                maskTelefono: "#########",
                maskCelular: "##########",
            }
        },
        watch:{
            dialog(){
                this.cargaGeneral();
            }
        },
        computed: {
            listaProvincias: function(){
                return (!_.isUndefined(this.itemsProvincias) ? _.clone(this.itemsProvincias) : []);
            },
            listaCantones: function(){
                return (!_.isUndefined(this.itemsCantones) ? _.clone(this.itemsCantones) : []);
            },
            listaEstados: function(){
                let lista = this.itemsEstados;

                return _.filter(lista,function(obj){
                    return _.toUpper(obj.nombre_estado) != _.toUpper('TODOS') 
                });
            }
        },
        methods: {
            cargaGeneral: function(){
                if(!_.isUndefined(_.get(this.$refs,'form_aseguradora',undefined)))
                    this.$refs.form_aseguradora.resetValidation();
                
                this.listCantones = [];
                this.imageName= null;
                this.imageUrl= null;
                this.imageFile= null;
            },
            onListarCantones(){
                var objeto = {
                                opcion         : 'L',
                                idProvincia    : this.editedItem.idProvincia,
                                idEstado       : this.editedItem.estado 
                            };
                return this.onListar('administrador/canton/listar',objeto,'listCantonesModal').catch((e) => { mensajesAlerta(e,'E') });
            },
            submit() {
                try {
                    if(!this.$refs.form_aseguradora.validate()) throw mensajeEstandar.corregirInformacion;
                    if(_.isNull(this.editedItem.logo)) throw mensajeEstandar.faltaIcono;
                        this.save();
                } catch (error) {
                    mensajesAlerta(error,'I')
                }
            },
            pickFile () {
                this.$refs.image.click ()
            },
            onFilePicked (e) {
                try {
                    var files = e.target.files
                    if(_.isUndefined(files[0])) throw mensajeEstandar.archivo;
                    if(files[0].name.lastIndexOf('.') <= 0) throw  mensajeEstandar.archivo;
                    if(files[0].name.search('.png') == -1 && files[0].name.search('.jpg') == -1) throw mensajeEstandar.archivo;

                        var fr = new FileReader ()
                        fr.readAsDataURL(files[0])
                        fr.addEventListener('load', () => {
                            this.$set(this.$parent.$parent.objetAseguradora,'logo',fr.result);
                            this.$forceUpdate();
                            this.imageFile = files[0]//Este es un archivo de imagen que se puede enviar al servidor 
                        })

                } catch (error) {
                    this.imageName = null;
                    this.imageFile = null;
                    mensajesAlerta(error,'I');
                }
		    }
        }
    }
</script>